import * as React from "react";
import { Tooltip, Grid, Icon } from "../../../common/MaterialComponent";
import { ButtonPrimary } from "../../../common/sharedStyle";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";
import { GroupItem, IExcel } from "../../../common/batchNotificationInterface";
import { GroupName } from "../GroupName/GroupName";
import { ExcelFileUpload } from "../ExcelFileUpload/ExcelFileUpload";
import { GroupDetailTablePreview } from "../GroupDetailTablePreview/GroupDetailTablePreview";
import styles from "../GroupConfiguration/GroupConfiguration.style";

export interface GroupDetailRowProps {
	dynamicVariables: any[];
	excelData: IExcel;
	item: GroupItem;
	onGroupNameChanged: (name: string) => void;
	onRemoveClicked?: () => void;
	onExcelDataChanged: (excelData: IExcel) => void;
	isReadOnly: boolean;
	showRemoveRowButton: boolean;
	highlightRequiredDetail: boolean;
}

export const GroupDetailRow: React.FC<GroupDetailRowProps> = ({
	dynamicVariables,
	item,
	onGroupNameChanged,
	onRemoveClicked,
	isReadOnly,
	showRemoveRowButton,
	onExcelDataChanged,
	excelData,
	highlightRequiredDetail,
}) => {
	const strings = useGetComponentStringsContext().GroupConfiguration;
	const classes = styles();

	return (
		<Grid
			container
			xs={12}
			key={item.rowId}
			className={classes.groupDivider}
			item={true}
			data-testid="groupDetailRowContainer"
		>
			<Grid xs={6} item={true}>
				<GroupName
					groupNameValue={item.groupDetail.name}
					onGroupNameChange={(value: string) => onGroupNameChanged(value)}
					isReadOnly={isReadOnly}
					highlightRequiredDetail={highlightRequiredDetail}
				/>
			</Grid>
			<Grid xs={4} item={true}>
				<ExcelFileUpload
					dynamicVariables={dynamicVariables}
					rowId={item.rowId}
					groupDetail={item.groupDetail}
					excelData={excelData}
					isReadOnly={isReadOnly}
					highlightRequiredDetail={highlightRequiredDetail}
					onExcelDataUpdate={(excelData: IExcel) => {
						onExcelDataChanged(excelData);
					}}
				/>
			</Grid>
			{onRemoveClicked && showRemoveRowButton ? (
				<Grid xs={2} item={true}>
					<div className={classes.removeRowContainer}>
						<Tooltip title={strings.removeGroupToolTip}>
							<span>
								<ButtonPrimary
									variant="contained"
									color="primary"
									className={classes.removeRowButton}
									onClick={() => onRemoveClicked()}
									disabled={isReadOnly}
									data-testid="removeGroupDetail"
								>
									<Icon>close</Icon>
								</ButtonPrimary>
							</span>
						</Tooltip>
					</div>
				</Grid>
			) : (
				""
			)}
			{excelData && excelData.contentData.length > 0 && (
				<GroupDetailTablePreview
					excelData={excelData}
					onExcelDataUpdate={(excelData: IExcel) => {
						onExcelDataChanged(excelData);
					}}
				/>
			)}
		</Grid>
	);
};
